import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { STYLE_OPTIONS } from 'src/constants';

const CounterWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
}));

function CharacterCounter({
  currentLength,
  maxLength,
  isError = false,
  isMobile = false,
}) {
  return (
    <CounterWrapper>
      <Typography
        variant="caption"
        color={isError ? STYLE_OPTIONS.COLOR_RED : STYLE_OPTIONS.COLOR_GREY_600}
      >
        {currentLength}
      </Typography>
      <Typography
        variant="caption"
        color={STYLE_OPTIONS.COLOR_GREY_600}
      >
        {`/${maxLength} ${isMobile ? '' : 'characters'}`}
      </Typography>
    </CounterWrapper>
  );
}

CharacterCounter.propTypes = {
  currentLength: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
  isError: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default CharacterCounter;
